<template>
  <div>
    <!-- <title-bar :title="$lang.Depósito"></title-bar> -->

    <div
      class="d-flex-s"
      style="
        height: 55px;
        background: #232433;
        padding: 0 10px;
        position: sticky;
        top: 0;
        z-index: 999;
      "
    >
      <div class="d-flex">
        <van-icon @click="goLeft()" name="arrow-left" size="20" />
        <span class="f-t-16 m-l-10">{{ $lang.Depósito }}</span>
        <div
          class="d-flex m-l-20 f-t-15"
          style="background: #181924; padding-right: 10px; border-radius: 20px"
        >
          <img src="../../assets/img/otgame/amount.png" width="15" />
          <span
            class="m-l-5"
            style="color: rgb(255, 214, 50); min-width: 50px; padding: 2px 0"
            >{{ blance }}</span
          >
        </div>
      </div>
      <p @click="goToRecord" class="f-t-15" style="text-decoration: underline">
        {{ $lang.common_txt256 }}
      </p>
    </div>

    <div class="RechargeCont-cont">
      <div class="d-flex-s" style="margin-bottom: 15px">
        <p class="f-t-15 f-w">{{ $lang.common_txt308 }}</p>
        <p style="color: #1bcd0d; text-decoration: underline; cursor: pointer" @click="$jumpTo('/vipLevels')">
          {{ $lang.common_txt309 }}
        </p>
      </div>
      <!-- <div class="d-flex recharge-item m-t-10" style="flex-flow: wrap row">
        <div
          v-for="(item, index2) in paymentList"
          :key="index2"
          @click="tabIndex(index2)"
          class="type-item d-flex"
          style="justify-content: center"
          :class="{ 'active-bor': selectIndex === index2 }"
        >
          <img
            :src="
              selectIndex === index2
                ? item.paymentIconUrl.replace('.png', '_sel.png')
                : item.paymentIconUrl
            "
            width="20"
            class="m-r-5"
          />
          {{ item.paymentName }}
        </div>
      </div> -->
      <!-- 修复：移除可选链操作符，改用Vue 2支持的写法 -->
      <div
        v-if="paymentKey === 'usdt'"
      >
        <!-- <p class="f-t-14 m-t-10">{{ $lang.common_txt246 }}</p> -->
        <div class="d-flex m-t-10">
          <div
            v-for="(item, index) in ['Tron(TRC20)', 'Ethereum(ERC20)']"
            :key="index"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 10px;
              border-radius: 10px;
              margin-right: 10px;
              margin-bottom: 10px;
              background: #454654;
            "
            :class="{ 'active-type2': selectWl === index }"
            @click="getSelectWl(index)"
          >
            {{ item }}
          </div>
        </div>
        <!-- <div>
          {{ $lang.common_txt257 }}
        </div> -->
      </div>

      <!-- 首充赠送活动提示 -->
      <div v-if="firstRecharge && activities.length > 0" class="first-recharge-banner">
        <img src="../../assets/img/otgame/recharge_4.png" width="20" />
        <span class="first-recharge-banner__text">{{ $lang.rc_first_deposit_bonus || 'First Deposit Bonus' }}</span>
      </div>

      <van-empty
        v-if="!paymentList.length && !showOverlay"
        :image="require('../../assets/img/common/img_no_data.png')"
        :description="paymentErrorMessage || $lang.noempt || 'No payment channels'"
      />

      <div class="amount-box-list d-flex-s">
        <div
          class="amount-box-list-item"
          v-for="(item, index) in dataList"
          :key="index"
          :class="{ active: index === selectAmountIndex || item.isActive }"
          @click="selectAmount(index, item)"
        >
          <div class="t-c">
            <span
              v-if="firstRecharge && item.bonus"
              class="amount-bonus-badge"
            >+{{ $formatNumberWithCommas(item.bonus) }}</span>
            <span style="width: 100%" class="t-c f-w f-t-14">
              {{ $formatNumberWithCommas(item.amount) }}</span
            >
          </div>
        </div>
      </div>

      <p style="color: #7c99ab; margin-top: 5px">
        {{ $lang.common_txt311 }} {{ displayedMinAmount }}
      </p>
      <van-field
        v-model="amount"
        :placeholder="$lang.common_txt143"
        class="custom-field m-t-5"
        type="number"
        :style="{ borderColor: focus ? '#55657E' : '#55657E' }"
        @input="handleInput"
        @focus="focus = true"
        @blur="focus = false"
      >
        <template #left-icon>
          <!-- 修复：移除可选链操作符 -->

          <div class="d-flex">
            <span class="f-t-15 m-r-10" style="color: #c9dae9"
              >{{
                paymentKey !== 'usdt'
                  ? getCurrency
                  : 'U'
              }}
            </span>
            <span style="margin-top: -3px">|</span>
          </div>
        </template>
      </van-field>
      <p class="m-t-5 d-flex" style="cursor: pointer" @click="$jumpTo('/vipLevels')">
        <img
          :src="
            require(`@/assets/img/vip/V${
              InitDate.vipLevel ? InitDate.vipLevel : 0
            }.png`)
          "
          height="18"
        />
        <span class="m-l-5">{{ $lang.common_txt312 }}</span>
      </p>
      <div
        style="
          background: #222534;
          border: 1px solid #555666;
          border-radius: 8px;
          padding: 10px;
          margin-top: 5px;
        "
      >
        <div class="f-t-15">
          <span style="color: #21dd17">
            {{ $lang.common_txt313 }}
          </span>
          <span style="color: #ffcd34">{{ totalMount }}</span>
        </div>
      </div>

      <!-- 修复：移除可选链操作符 -->
      <p
        v-if="paymentKey === 'usdt'"
        class="f-t-13 m-t-5 m-l-10"
      >
        ≈ {{ $formatNumberWithCommas(TotalHl) }}{{ getCurrency }} ({{
          $lang.common_txt247
        }})
      </p>

      <div class="t-c" style="margin-top: 20px">
        <van-button
          @click="submit"
          size="large"
          class="custom-button f-t-18"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
          :class="{ 'active-b': isLoading }"
          :disabled="isLoading || !paymentList.length"
        >
          {{ $lang.common_txt314 }} {{ getCurrency }} {{ amount }}
        </van-button>
      </div>
      <div v-if="!['usdt', 'otpay'].includes(paymentKey)">
        <div
          class="d-flex f-t-15"
          style="margin: 15px 0 20px; justify-content: center"
        >
          <img :src="GET_ICONURL" width="25" />
          <span
            style="font-weight: bold; margin-left: 3px; margin-right: 10px"
            >{{ GET_AREACODE }}</span
          >

          <span>{{ account }}</span>
        </div>
        <div
          style="
            color: #aeb6cf;
            font-size: var(--vk-fs-15);
            font-weight: bold;
            text-align: center;
            margin-bottom: 15px;
            line-height: 20px;
          "
        >
          {{ $lang.common_txt362 }}
        </div>
      </div>
      <div class="deposit_share t-c">
        <p class="f-t-15 f-w" style="color: #1cdd32">
          {{ $lang.common_txt315 }}
        </p>
        <p
          class="m-t-5"
          style="line-height: 20px"
          v-html="$lang.common_txt316"
        ></p>
        <img
          src="../../assets/img/otgame/zjm_40.png"
          width="35"
          style="cursor: pointer"
          @click="openTgCustomerService"
        />
      </div>

      <div class="d-flex m-t-15" style="justify-content: center">
        <img src="../../assets/img/otgame/cdk_4.png" height="12" width="28%" />
        <p style="margin: 0 20px">{{ $lang.common_txt317 }}</p>
        <img src="../../assets/img/otgame/cdk_3.png" height="12" width="28%" />
      </div>
      <div
        v-html="$lang.common_txt30"
        class="l-h-20"
        style="width: 96%; margin: 0 auto; color: #6e728c"
      ></div>
    </div>
    <div
      v-if="paymentList.length"
      style="
        position: fixed;
        bottom: 60px;
        left: 0;
        right: 0;
        margin: 0 auto;
        max-width: var(--vk-pc-col);
        background: #1a212e;
      "
    >
      <div style="padding: 10px">
        <!-- 修改：从固定的['Fiat', 'Crypto']改为渲染paymentList -->
        <div class="d-flex">
          <div
            v-for="(item, index) in paymentList"
            :key="index"
            class="t-c f-t-13 f-w m-r-10"
            style="
              height: 58px;
              min-width: 58px;
              background: #3d4654;
              border-radius: 10px;
              padding-top: 10px;
            "
            :class="{ 'active-type': selectIndex === index }"
            @click="tabIndex(index)"
          >
            <!-- <img
              :src="
                selectIndex === index
                  ? item.paymentIconUrl.replace('.png', '_sel.png')
                  : item.paymentIconUrl
              "
              width="20"
              class="m-r-5"
            /> -->
            <img :src="item.paymentIconUrl" width="40" height="22" />
            <p>{{ item.paymentName }}</p>
          </div>
        </div>

        <div
          class="d-flex m-t-10"
          style="
            justify-content: center;
            border: 1px solid #fa9614;
            border-radius: 10px;
            padding: 6px 0;
            background: #263144;
          "
          :class="{
            'active-type3':
              paymentKey !== 'usdt'
          }"
        >
          <ui-icon name="info" :size="15" style="color: var(--vk-success)" />
          <span class="m-l-10" style="color: #1ccf0e">{{
            $lang.common_txt257
          }}</span>
        </div>
      </div>
    </div>

    <van-popup
      v-model="orangShow"
      closeable
      close-icon-position="top-right"
      style="
        background: #232433;
        width: 90%;
        border-radius: 10px;
        padding: 20px;
      "
    >
      <div>
        <div class="m-t-20 f-t-15 t-c f-w">
          {{ $lang.common_txt363 }}
        </div>
        <div style="line-height: 20px; margin-top: 10px">
          <div style="display: inline-block">
            <span v-html="$lang.common_txt365"></span>
            <span class="info-color">{{ formattedAwardRules }}{{ amount }}#</span>
            <span v-html="$lang.common_txt368"></span>
          </div>
          <p class="m-t-10 info-color t-c">
            <span>{{ $lang.common_txt366 }}</span>
            {{ amount }} <span>{{ $lang.common_txt367 }}</span>
          </p>
        </div>

        <van-field
          v-model="uLine"
          class="custom-field m-t-10"
          type="number"
          :placeholder="$lang.common_txt364"
          :maxlength="6"
        >
        </van-field>
        <van-button
          @click="submit"
          size="large"
          class="custom-button f-t-18 m-t-20"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
        >
          {{ $lang.Confirmar }}
        </van-button>
      </div>
    </van-popup>
    <van-popup
      v-model="payInfoShow"
      closeable
      close-icon-position="top-right"
      style="
        background: #232433;
        width: 90%;
        border-radius: 10px;
        padding: 20px;
      "
    >
      <div>
        <div
          class="m-t-10 f-t-18 t-c f-w d-flex"
          style="justify-content: center"
        >
          <img :src="paymentIconUrl" width="73" height="40" />
          <span>{{ paymentName }}</span>
        </div>
        <div style="line-height: 20px; margin-top: 10px">
          <p class="info-color">
            {{ $lang.common_txt370 }} {{ paymentName }}
            {{ $lang.common_txt374 }}
          </p>
          <p v-html="$lang.common_txt371"></p>
          <p v-html="$lang.common_txt372"></p>
          <p class="m-t-20" style="color: #ababac">{{ $lang.common_txt373 }}</p>
        </div>
        <van-button
          @click="payInfoShow = false"
          size="large"
          class="custom-button f-t-18 m-t-20"
          style="
            width: 100%;
            height: 48px;
            background: linear-gradient(270deg, #7b1af2, #a81ce6);
          "
        >
          {{ $lang.Confirmar }}
        </van-button>
      </div>
    </van-popup>
    <!-- 支付弹窗 -->
    <van-popup
      v-model="payShow"
      closeable
      close-icon-position="top-right"
      style="width: 90%; border-radius: 10px; height: 80%"
    >
      <div>
        <iframe
          :src="payUrl"
          scrolling="no"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
      </div>
    </van-popup>
    <!-- 全屏遮罩层 -->
    <van-overlay :show="showOverlay" class="full-screen-overlay">
      <div class="loading-container">
        <van-loading size="30" vertical color="#ffffff">{{
          $lang.common_txt67
        }}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Init, GetCsLink } from '@/api/common'
import {
  GetIsFbReport,
  Pay,
  RefreshExchangeRate,
  VnRechargeInitS
} from '@/api/modules/recharge'
import {
  buildPayOrderData,
  contentOf,
  defaultAmountIndex,
  failMessage,
  getOrderNo,
  getPaymentUrl,
  hasBlockedPaymentMethods,
  hasLocalToken,
  hasProvenEmptyPaymentList,
  isNeedLogin,
  isOk,
  isRechargePayReady,
  isUsablePaymentMethod,
  normalizeMoneyAmount,
  normalizeRechargeContent,
  openLogin,
  paymentAmountBounds,
  promoType,
  savePayOrderData,
  showError,
  toNumber
} from '@/components/recharge/paymentFlow'
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem } from '@/utils/safeStorage'
import { openExternalUrl, reportDisallowedHost, PAYMENT_HOST_ALLOWLIST } from './safeLayout'
import { openCustomerServiceUrl } from './csLink'
import { SINGLE_COUNTRY } from '@/config/singleCountry'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function browserWindow() {
  return typeof window !== 'undefined' && window ? window : null
}

function getKwaiq() {
  const win = browserWindow()
  try {
    return win && win.kwaiq ? win.kwaiq : null
  } catch (e) {
    return null
  }
}

function payloadOf(res) {
  if (!res || typeof res !== 'object') return {}
  const base = contentOf(res)
  if (Object.keys(base).length) return base
  for (const key of ['extra', 'page', 'data']) {
    if (res[key] && typeof res[key] === 'object') return res[key]
  }
  return res
}

function rechargePayloadOf(res) {
  const payload = payloadOf(res)
  if (payload.paymentList) return payload
  for (const key of ['list', 'records', 'dataList']) {
    if (Array.isArray(payload[key])) {
      return { ...payload, paymentList: payload[key] }
    }
  }
  for (const key of ['extra', 'page', 'data', 'content']) {
    const nested = payload[key]
    if (nested && typeof nested === 'object') {
      const normalized = rechargePayloadOf(nested)
      if (normalized.paymentList) return { ...payload, ...normalized }
    }
  }
  return payload
}

function localMarkerToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isLocalActiveMarkerValue(value) {
  const token = localMarkerToken(value)
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token)
}

function isLocalFalseMarkerValue(value) {
  const token = localMarkerToken(value)
  return value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)
}

function isLocalUnavailableToken(value) {
  const token = localMarkerToken(value)
  return !!token && (
    token.includes('dataunavailable') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('read only') ||
    token.includes('readonly') ||
    token.includes('write_blocked') ||
    token.includes('write-blocked') ||
    token.includes('write blocked') ||
    token.includes('writeblocked') ||
    token.includes('backend_blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend_failure') ||
    token.includes('backend-failure') ||
    token.includes('backend failure') ||
    token.includes('backendfailure') ||
    token.includes('payment_backend_blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('payment-status-unconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('false_proof') ||
    token.includes('false-proof') ||
    token.includes('false proof') ||
    token.includes('falseproof') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('read_unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read_failed') ||
    token.includes('read-failed') ||
    token.includes('read failed') ||
    token.includes('route_unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('technical_marker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical_error') ||
    token.includes('technical-error') ||
    token.includes('technical error') ||
    token.includes('technicalerror') ||
    token.includes('technical_exception') ||
    token.includes('technical-exception') ||
    token.includes('technical exception') ||
    token.includes('technicalexception') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('notconnected') ||
    token.includes('mock') ||
    token.includes('stub') ||
    token.includes('fallback') ||
    token.includes('unsupported') ||
    token.includes('not_supported') ||
    token.includes('not-supported') ||
    token.includes('not supported') ||
    token.includes('query_only') ||
    token.includes('query-only') ||
    token.includes('query only') ||
    token.includes('only_query') ||
    token.includes('only-query') ||
    token.includes('only query') ||
    token.includes('只支持查询') ||
    token.includes('仅支持查询')
  )
}

function isLocalMarkerTextKey(key) {
  return [
    'status',
    'state',
    'result',
    'code',
    'errorcode',
    'msg',
    'message',
    'errormsg',
    'errormessage',
    'reason',
    'desc',
    'description',
    'readonlymessage'
  ].includes(localMarkerToken(key))
}

function isLocalMarkerMessageKey(key) {
  return [
    'msg',
    'message',
    'errormsg',
    'errormessage',
    'reason',
    'desc',
    'description',
    'readonlymessage'
  ].includes(localMarkerToken(key))
}

const localMarkerKeys = [
  'dataUnavailable',
  'data_unavailable',
  'readOnly',
  'readOnlyQuery',
  'readOnlyAction',
  'readonly',
  'read_only',
  'read_only_query',
  'read_only_action',
  'writeBlocked',
  'write_blocked',
  'backendBlocked',
  'backend_blocked',
  'backendFailure',
  'backend_failure',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'falseProof',
  'false_proof',
  'readFailure',
  'read_failure',
  'readUnavailable',
  'read_unavailable',
  'readFailed',
  'read_failed',
  'routeUnavailable',
  'route_unavailable',
  'technicalMarker',
  'technical_marker',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'notConnected',
  'not_connected',
  'mock',
  'mockFallback',
  'mock_fallback',
  'stub',
  'fallback',
  'unsupported',
  'notSupported',
  'not_supported',
  'queryOnly',
  'query_only',
  'onlyQuery',
  'only_query'
]

const localOrderWritableKeys = [
  'orderWritable',
  'order_writable'
]

const localProofKeys = [
  'writeProof',
  'write_proof',
  'serverProof',
  'server_proof',
  'orderProof',
  'order_proof',
  'paymentUrlProof',
  'payment_url_proof',
  'payProof',
  'pay_proof',
  'paymentProof',
  'payment_proof',
  'statusProof',
  'status_proof',
  'affectedProof',
  'affected_proof',
  'affectedRowsProof',
  'affected_rows_proof',
  'rowsAffectedProof',
  'rows_affected_proof'
]

const localPaymentStatusKeys = [
  'paymentStatus',
  'payment_status',
  'payStatus',
  'pay_status',
  'orderStatus',
  'order_status',
  'tradeStatus',
  'trade_status'
]

function isLocalUnconfirmedPaymentStatus(value) {
  const token = localMarkerToken(value)
  return token === 'unconfirmed' ||
    token === 'not_confirmed' ||
    token === 'not-confirmed' ||
    token === 'not confirmed' ||
    token === 'status_unconfirmed' ||
    token === 'status-unconfirmed' ||
    token === 'status unconfirmed' ||
    token === 'payment_status_unconfirmed' ||
    token === 'payment-status-unconfirmed' ||
    token === 'payment status unconfirmed' ||
    token === 'paymentstatusunconfirmed'
}

function hasLocalPayloadFields(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasLocalPayloadFields(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (['paymentList', 'quickSelect', 'activities', 'list', 'records', 'dataList'].includes(key)) {
      return Array.isArray(value) && value.length > 0
    }
    if ([
      'paymentId',
      'paymentKey',
      'channelId',
      'channelCode',
      'orderNo',
      'orderId',
      'payOrderNo',
      'paymentOrderNo',
      'paymentNo',
      'tradeNo',
      'payUrl',
      'paymentUrl',
      'cashierUrl',
      'checkoutUrl',
      'redirectUrl',
      'qrcode',
      'qrCode',
      'paymentUrlProof',
      'payment_url_proof',
      'payProof',
      'pay_proof',
      'orderProof',
      'order_proof',
      'serverProof',
      'server_proof',
      'writeProof',
      'write_proof',
      'affectedProof',
      'affected_proof'
    ].includes(key)) {
      return value !== undefined && value !== null && String(value).trim() !== ''
    }
    return value && typeof value === 'object' && hasLocalPayloadFields(value, depth + 1, seen)
  })
}

function isLocalMetadataOnlyObject(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return false
  const keys = Object.keys(payload)
  if (!keys.length || hasLocalPayloadFields(payload)) return false
  return keys.every(key => {
    const value = payload[key]
    if (isLocalMarkerTextKey(key) || localMarkerToken(key) === 'success') return true
    if (localMarkerKeys.includes(key) || isLocalUnavailableToken(key)) {
      return !isLocalActiveMarkerValue(value) && !isLocalUnavailableToken(value)
    }
    return false
  })
}

function isLocalMetadataOnlyMessage(value) {
  const token = localMarkerToken(value)
  return Boolean(token) && (
    token.includes('metadata-only') ||
    token.includes('metadata only')
  )
}

function shouldIgnoreLocalMetadataMessage(payload, key, rootHasPayload) {
  return rootHasPayload &&
    isLocalMarkerMessageKey(key) &&
    (isLocalMetadataOnlyObject(payload) || isLocalMetadataOnlyMessage(payload[key]))
}

function isLocalOkMarker(value) {
  const token = localMarkerToken(value)
  return ['ok', 'success', 'successful', 'succeed', 'succeeded', '0', '00', '0000', '000000', '200'].includes(token) ||
    value === true ||
    value === 1 ||
    ['true', '1', 'yes', 'on'].includes(token)
}

function hasLocalOkMarker(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasLocalOkMarker(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (['status', 'state', 'result', 'code', 'errorCode', 'success'].includes(key) && isLocalOkMarker(value)) return true
    return value && typeof value === 'object' && hasLocalOkMarker(value, depth + 1, seen)
  })
}

function isLocalProvenEmptyPaymentList(payload, list) {
  return typeof hasProvenEmptyPaymentList === 'function' && hasProvenEmptyPaymentList(payload, list)
}

function isLocalOkResponse(payload) {
  return !!(payload && !isNeedLogin(payload) && (!isLocalUnavailableResponse(payload) || isLocalProvenEmptyPaymentList(payload)) && hasLocalOkMarker(payload))
}

function stripLocalMetadataMessagesForGuard(payload, rootHasPayload = hasLocalPayloadFields(payload), depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return payload
  seen.push(payload)
  if (Array.isArray(payload)) {
    return payload.map(item => stripLocalMetadataMessagesForGuard(item, rootHasPayload, depth + 1, seen))
  }
  const next = {}
  Object.keys(payload).forEach(key => {
    const value = payload[key]
    if (shouldIgnoreLocalMetadataMessage(payload, key, rootHasPayload)) return
    next[key] = value && typeof value === 'object'
      ? stripLocalMetadataMessagesForGuard(value, rootHasPayload, depth + 1, seen)
      : value
  })
  return next
}

function isLocalSafePaymentUrl(url) {
  const value = String(url == null ? '' : url).trim()
  if (!value) return true
  const token = value.toLowerCase()
  if (
    token === '#' ||
    token === 'about:blank' ||
    token === 'javascript:void(0)' ||
    token.startsWith('javascript:') ||
    token.startsWith('vbscript:') ||
    token.startsWith('data:') ||
    token.includes('mock') ||
    token.includes('stub') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('read only')
  ) return false
  try {
    const parsed = new URL(value)
    const okShape = ['http:', 'https:'].includes(parsed.protocol) && Boolean(parsed.hostname)
    if (okShape) reportDisallowedHost('payment', parsed.href, PAYMENT_HOST_ALLOWLIST) // log-only:仅观测,不拦截
    return okShape
  } catch (e) {
    return false
  }
}

function isLocalUnavailableResponse(payload, depth = 0, seen = [], rootHasPayload = hasLocalPayloadFields(payload)) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  if (isUsablePaymentMethod(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) {
    return payload.some(item => isLocalUnavailableResponse(item, depth + 1, seen, rootHasPayload))
  }
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (key === 'paymentList') return false
    if (localOrderWritableKeys.includes(key) && isLocalFalseMarkerValue(value)) return true
    if (localProofKeys.includes(key) && isLocalFalseMarkerValue(value)) return true
    if (localPaymentStatusKeys.includes(key) && isLocalUnconfirmedPaymentStatus(value)) return true
    if (localMarkerKeys.includes(key) && (isLocalActiveMarkerValue(value) || isLocalUnavailableToken(value))) return true
    if (isLocalUnavailableToken(key) && isLocalActiveMarkerValue(value)) return true
    if (value && typeof value === 'object') return isLocalUnavailableResponse(value, depth + 1, seen, rootHasPayload)
    if (shouldIgnoreLocalMetadataMessage(payload, key, rootHasPayload)) return false
    return isLocalMarkerTextKey(key) && isLocalUnavailableToken(value)
  })
}

function isLocalUnavailablePaymentMethod(payment) {
  if (isUsablePaymentMethod(payment)) return false
  return isLocalUnavailableResponse(payment)
}

function isLocalReadFailureResponse(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  if (isUsablePaymentMethod(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => isLocalReadFailureResponse(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (['readFailure', 'read_failure', 'readFailed', 'read_failed'].includes(key)) {
      return isLocalActiveMarkerValue(value) || isLocalUnavailableToken(value)
    }
    if (value && typeof value === 'object') return isLocalReadFailureResponse(value, depth + 1, seen)
    if (!isLocalMarkerTextKey(key)) return false
    const token = localMarkerToken(value)
    return token.includes('read_failure') ||
      token.includes('read-failure') ||
      token.includes('read failure') ||
      token.includes('read_failed') ||
      token.includes('read-failed') ||
      token.includes('read failed')
  })
}

function isLocalPublicReadUnavailableToken(value) {
  const token = localMarkerToken(value)
  return token.includes('public read unavailable') ||
    token.includes('public_read_unavailable') ||
    token.includes('public-read-unavailable') ||
    token.includes('publicreadunavailable')
}

function isLocalPublicReadUnavailableResponse(payload, depth = 0, seen = []) {
  if (isLocalPublicReadUnavailableToken(payload)) return true
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => isLocalPublicReadUnavailableResponse(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (isLocalPublicReadUnavailableToken(key) || isLocalPublicReadUnavailableToken(value)) return true
    return value && typeof value === 'object' && isLocalPublicReadUnavailableResponse(value, depth + 1, seen)
  })
}

function showLocalError(vm, res, fallback) {
  if (isLocalPublicReadUnavailableResponse(res)) return
  showError(vm, res, fallback)
}

export default {
  name: 'RechargeCont',
  data() {
    return {
      paymentName: '',
      payUrl: '',
      payShow: false,
      uLine: '',
      showOverlay: false, // 控制遮罩层的显示与隐藏
      showBg: false,
      isLoading: false,
      agree: false,
      selectIndex: 0,
      selectAmountIndex: null,
      amount: '',
      focus: false,
      dataList: [],
      paymentType: '',
      paymentKey: '',
      paymentId: '',
      rechargeFees: 0,
      visible: this.value, // 内部状态
      paymentList: [],
      activities: [],
      firstRecharge: false,
      selectWl: 0,
      exchRate: 0, //汇率
      blance: 0,
      minAmount: 0,
      InitDate: {},
      totalMount: 0,
      account: '',
      orangShow: false,
      awardRules: '',
      payInfoShow: false,
      paymentIconUrl: '',
      paymentErrorMessage: ''
    }
  },
  watch: {
    paymentList: {
      deep: true, // 开启深度监听
      handler() {
        if (this.paymentList.length > 0) {
          this.tabIndex(0)
          const quickSelect = Array.isArray(this.paymentList[0].quickSelect)
            ? this.paymentList[0].quickSelect
            : []
          const selectedIndex = defaultAmountIndex(quickSelect)
          if (selectedIndex >= 0) {
            this.selectAmount(selectedIndex, quickSelect[selectedIndex])
            this.amount = quickSelect[selectedIndex].amount
          } else {
            this.selectAmountIndex = null
            this.amount = ''
            this.totalMount = 0
          }
          // 如果默认选中的是USDT，刷新汇率
          if (this.paymentList[0].paymentKey === 'usdt') {
            this.RefreshExchangeRate()
          }
        } else {
          this.dataList = []
          this.selectIndex = 0
          this.selectAmountIndex = null
          this.paymentId = ''
          this.paymentKey = ''
          this.paymentType = ''
          this.amount = ''
          this.totalMount = 0
        }
      }
    }
  },
  computed: {
    TotalHl() {
      return this.amount * this.exchRate
    },
    displayedMinAmount() {
      return paymentAmountBounds(this.paymentList[this.selectIndex]).minAmount
    },
    formattedAwardRules() {
      return this.formatAwardRules(this.awardRules)
    }
  },
  mounted() {
    if (hasLocalToken(this)) {
      this.VnRechargeInitS()
      this.Init()
    } else {
      this.requireLogin()
    }
  },
  methods: {
    requireLogin() {
      safeRemoveStorageItem(getLocalStorage(), 'token')
      openLogin(this)
      this.$jumpTo('/home', { isValue: 'isLogin' }, { replace: true })
    },
    goToRecord() {
      this.$jumpTo('/recordOrder')
    },
    async openTgCustomerService() {
      try {
        const data = await GetCsLink()
        openCustomerServiceUrl(data, 'telegram')
      } catch (e) {
        openCustomerServiceUrl(null, 'telegram')
      }
    },
    async Init() {
      try {
        const data = await Init()
        if (isOk(data) && !isLocalUnavailableResponse(data)) {
          const content = payloadOf(data)
          this.InitDate = content
          this.blance = toNumber(content._balUsable || content.balance, this.blance)
          this.account = content._account || content.account || this.account
        } else if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (isLocalUnavailableResponse(data)) {
          showLocalError(this, data, this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.')
        }
      } catch (e) {
        showLocalError(this, e, this.$lang.request_failed || 'Account initialization failed. Please try again later.')
      }
    },
    goLeft() {
      this.$router.go(-1)
    },
    async RefreshExchangeRate() {
      const fallbackMessage = this.$lang.exchange_rate_failed || 'Failed to refresh the exchange rate. Please try again later.'
      try {
        const data = await RefreshExchangeRate({
          exccType: 'USDT',
          rwType: 'r'
        })
        if (isOk(data) && !isLocalUnavailableResponse(data)) {
          const content = payloadOf(data)
          const nextRate = toNumber(
            content.exchRate ||
              content.rechargeExchangeRate ||
              content.exchangeRate ||
              content.withdrawExchangeRate,
            0
          )
          if (content.rateFallback || content.dataUnavailable || nextRate <= 0) {
            this.exchRate = 0
            this.$toast({
              message: failMessage(data, fallbackMessage),
              icon: 'cross'
            })
            return
          }
          this.exchRate = nextRate
        } else if (isNeedLogin(data)) {
          this.requireLogin()
        } else {
          this.exchRate = 0
          const message = isLocalUnavailableResponse(data)
            ? (this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.')
            : fallbackMessage
          showLocalError(this, data, message)
        }
      } catch (e) {
        this.exchRate = 0
        if (isLocalPublicReadUnavailableResponse(e)) return
        this.$toast({
          message: fallbackMessage,
          icon: 'cross'
        })
      }
    },
    getSelectWl(i) {
      this.selectWl = i
    },
    goToRechage() {
      this.$jumpTo('/recordOrder')
    },
    goBack() {
      this.visible = false
    },
    async VnRechargeInitS() {
      this.paymentErrorMessage = ''
      try {
        const data = await VnRechargeInitS()
        const rawContent = rechargePayloadOf(data)
        const rawPaymentList = Array.isArray(rawContent.paymentList) ? rawContent.paymentList : []
        const content = normalizeRechargeContent({
          ...rawContent,
          paymentList: rawPaymentList.filter(item => !isLocalUnavailablePaymentMethod(item))
        })
        if (content.paymentList.length > 0 && !isNeedLogin(data)) {
          this.paymentList = content.paymentList
          this.dataList = content.paymentList.length > 0 ? content.paymentList[0].quickSelect : []
          this.activities = content.activities
          this.firstRecharge = content.firstRecharge
          this.blance = content.balance
          this.account = content.account
          return
        }
        if (isLocalReadFailureResponse(data)) {
          this.paymentErrorMessage = failMessage(data, this.$lang.request_failed || 'Failed to load payment channels. Please try again later.')
          if (!isLocalPublicReadUnavailableResponse(data)) {
            this.$toast({
              message: this.paymentErrorMessage,
              icon: 'cross'
            })
          }
        } else if (isLocalOkResponse(data)) {
          const provenEmptyPaymentList = isLocalProvenEmptyPaymentList(data, rawPaymentList)
          if (isLocalUnavailableResponse(data) && !provenEmptyPaymentList) {
            this.paymentList = []
            this.dataList = []
            this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
            this.$toast({
              message: this.paymentErrorMessage,
              icon: 'cross'
            })
            return
          }
          this.paymentList = content.paymentList
          this.dataList = content.paymentList.length > 0 ? content.paymentList[0].quickSelect : []
          this.activities = content.activities
          this.firstRecharge = content.firstRecharge
          this.blance = content.balance
          this.account = content.account
          if (!content.paymentList.length && !provenEmptyPaymentList) {
            this.paymentErrorMessage = this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.'
          }
          if (!content.paymentList.length && !provenEmptyPaymentList && (!rawPaymentList.length || hasBlockedPaymentMethods(rawPaymentList))) {
            this.$toast({
              message: this.paymentErrorMessage,
              icon: 'cross'
            })
          }
        } else if (isNeedLogin(data)) {
          this.requireLogin()
        } else {
          this.paymentList = []
          this.dataList = []
          this.selectAmountIndex = null
          this.amount = ''
          this.totalMount = 0
          this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
          showLocalError(this, data, this.paymentErrorMessage)
        }
      } catch (e) {
        this.paymentErrorMessage = failMessage(e, this.$lang.request_failed || 'Failed to initialize payment channels. Please try again later.')
        showLocalError(this, e, this.paymentErrorMessage)
      }
    },
    async GetIsFbReport(v) {
      try {
        const data = await GetIsFbReport({
          inviteCode: safeGetStorageItem(getLocalStorage(), 'id')
        })
        if (isOk(data)) {
          const content = payloadOf(data)
          const reportValue = parseInt(toNumber(v, 0) * 0.1)
          // 运行时币种派生:优先真实币种,回退单国币种,最终兜底 XOF(原写死 NGN)
          const reportCurrency = this.getCurrency || (SINGLE_COUNTRY && SINGLE_COUNTRY.currency) || 'XOF'
          if (content.isReport && reportValue > 0) {
            const kwaiq = getKwaiq()
            if (
              content.target === 'ks' &&
              content.fbPixId &&
              kwaiq &&
              typeof kwaiq.load === 'function' &&
              typeof kwaiq.instance === 'function'
            ) {
              kwaiq.load(content.fbPixId)
              const tracker = kwaiq.instance(content.fbPixId)
              if (tracker && typeof tracker.track === 'function') {
                tracker.track('addToCart', {
                  value: reportValue,
                  currency: reportCurrency
                })
              }
            } else if (content.fbPixId) {
              const pixel = this.$pixel || null
              if (pixel && typeof pixel.setFbId === 'function') {
                pixel.setFbId(content.fbPixId)
              }
              if (pixel && typeof pixel.callTrackHasPara === 'function') {
                pixel.callTrackHasPara('track', 'AddToCart', reportValue, reportCurrency)
              }
              const jsonData = `"""{"data":[{"event_name": "Lead","content_name": "Recharge Form","value": ${reportValue},"currency": "${reportCurrency}"}]}"""`
              if (pixel && typeof pixel.sendEventToAndroid === 'function') {
                pixel.sendEventToAndroid(jsonData)
              }
            }
          }
        }
      } catch (e) {
        // Tracking failures must not block recharge.
      }
    },
    async submit() {
      if (this.isLoading) return
      if (!hasLocalToken(this)) {
        this.requireLogin()
        return
      }
      const selectedPayment = this.paymentList[this.selectIndex]
      const bounds = paymentAmountBounds(selectedPayment)
      const amountCheck = normalizeMoneyAmount(this.amount, bounds)
      if (!isUsablePaymentMethod(selectedPayment) || !this.paymentId) {
        this.$toast({
          message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
          icon: 'cross'
        })
        return
      }
      if (!amountCheck.ok) {
        this.$toast({
          message: `${this.$lang.common_txt311 || 'Minimum amount'} ${bounds.minAmount}`,
          icon: 'cross'
        })
        return
      }
      if (
        this.paymentList.length > 0 &&
        this.paymentKey === 'orange' &&
        !this.orangShow &&
        this.GET_PLATFORM !== 'cgbet'
      ) {
        this.orangShow = true
        return
      }
      if (this.orangShow) {
        if (this.uLine.length < 6) {
          this.$toast({
            message: this.$lang.common_txt375,
            icon: 'cross'
          })
          return
        }
      }
      this.isLoading = true
      this.showOverlay = true
      this.paymentErrorMessage = ''
      this.payShow = false
      this.payUrl = ''
      try {
        if (this.paymentKey === 'usdt') {
          if (this.selectWl === 0) {
            this.uLine = 'TRON'
          } else if (this.selectWl === 1) {
            this.uLine = 'ETH'
          }
        }
        const data = await Pay({
          paymentAmount: amountCheck.amount,
          paymentId: this.paymentId,
          paymentKey: this.paymentKey,
          paymentType: this.paymentType,
          rechargeFees: this.rechargeFees,
          currency: this.getCurrency,
          uLine: this.uLine,
          phone: this.account,
          promoType: promoType(this.firstRecharge, this.activities, this.agree)
        })
        if (isLocalUnavailableResponse(data)) {
          this.payShow = false
          this.payUrl = ''
          this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
          this.$toast({
            message: this.paymentErrorMessage,
            icon: 'cross'
          })
          return
        }
        const paymentGuardData = stripLocalMetadataMessagesForGuard(data)
        let paymentReadyData = null
        if (isRechargePayReady(data)) {
          paymentReadyData = data
        } else if (isRechargePayReady(paymentGuardData)) {
          paymentReadyData = paymentGuardData
        }
        if (paymentReadyData) {
          const content = payloadOf(paymentReadyData)
          const paymentUrl = getPaymentUrl(content)
          const orderNo = getOrderNo(content)
          this.orangShow = false

          if (!paymentUrl && !orderNo) {
            this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
            this.$toast({
              message: this.paymentErrorMessage,
              icon: 'cross'
            })
            return
          }
          if (!isLocalSafePaymentUrl(paymentUrl)) {
            this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
            this.$toast({
              message: this.paymentErrorMessage,
              icon: 'cross'
            })
            return
          }

          this.GetIsFbReport(amountCheck.amount)

          if (this.paymentKey === 'usdt') {
            const orderData = buildPayOrderData(content, {
              paymentAmount: amountCheck.amount,
              paymentId: this.paymentId,
              paymentKey: this.paymentKey,
              wlType: this.selectWl === 0 ? 'TRC20' : 'ERC20'
            })
            if (!savePayOrderData(orderData)) {
              this.$toast({
                message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
                icon: 'cross'
              })
              return
            }
            this.$jumpTo('/payOrder')
          } else if (this.paymentKey === 'wave') {
            if (!openExternalUrl(paymentUrl)) {
              this.$toast({
                message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
                icon: 'cross'
              })
            }
          } else if (!['orange'].includes(this.paymentKey) && paymentUrl) {
            this.payShow = true
            this.payUrl = paymentUrl
          } else if (orderNo) {
            this.payInfoShow = true
          }
        } else if (isOk(data)) {
          this.paymentErrorMessage = failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.')
          this.$toast({
            message: this.paymentErrorMessage,
            icon: 'cross'
          })
        } else if (isNeedLogin(data)) {
          this.requireLogin()
        } else {
          showError(this, data)
        }
      } catch (e) {
        showError(this, e, this.$lang.request_failed || 'Failed to submit the deposit. Please try again later.')
      } finally {
        this.isLoading = false
        this.showOverlay = false
      }
    },
    tabIndex(i) {
      const payment = this.paymentList[i]
      if (!payment) return
      const bounds = paymentAmountBounds(payment)
      this.minAmount = bounds.minAmount
      this.selectIndex = i
      this.dataList = Array.isArray(payment.quickSelect) ? payment.quickSelect : []
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.paymentId = payment.paymentId
      this.paymentKey = String(payment.paymentKey || payment.paymentId || '').toLowerCase()
      this.paymentType = payment.paymentType
      this.rechargeFees = toNumber(payment.rechargeFees, 0)
      this.awardRules = payment.awardRules
      this.paymentIconUrl = payment.paymentIconUrl
      this.paymentName = payment.paymentName
      if (!this.dataList.length) {
        this.selectAmountIndex = null
        this.amount = ''
        this.totalMount = 0
      }
      if (this.paymentKey === 'usdt') {
        this.RefreshExchangeRate()
      }
    },
    selectAmount(i, v) {
      if (!v) return
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.selectAmountIndex = i
      this.amount = v.amount
      this.totalMount = this.firstRecharge && v.bonus
        ? toNumber(v.amount, 0) + toNumber(v.bonus, 0)
        : toNumber(v.amount, 0)
    },
    handleInput(i) {
      // 根据输入框的值更新按钮的激活状态
      let matchedBonus = 0
      this.dataList.forEach((item) => {
        item.isActive = toNumber(item.amount, 0) === toNumber(i, 0)
        if (item.isActive && this.firstRecharge && item.bonus) {
          matchedBonus = toNumber(item.bonus, 0)
        }
        this.selectAmountIndex = null
      })
      this.totalMount = this.firstRecharge && matchedBonus
        ? toNumber(i, 0) + matchedBonus
        : toNumber(i, 0)
    },
    formatAwardRules(rules) {
      if (Array.isArray(rules)) {
        return rules
          .map(item => this.formatAwardRules(item))
          .filter(Boolean)
          .join(' ')
      }
      if (rules && typeof rules === 'object') {
        return Object.values(rules)
          .map(item => this.formatAwardRules(item))
          .filter(Boolean)
          .join(' ')
      }
      return String(rules == null ? '' : rules).trim()
    }
  }
}
</script>

<style lang="less" scoped>
.deposit_share {
  background: #1d1f2d;
  border-radius: 5px;
  padding: 10px;
}
.RechargeCont-cont {
  padding: 3% 5% 0% 5%;
  overflow-y: auto;
  min-height: 73vh;
  max-height: 77vh;
  border-radius: 38px 38px 0 0;
}

.type-item {
  width: 25%;
  position: relative;
  border-radius: 10px;
  background: #454654;
  padding: 10px 0;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid;
}
.active-bor {
  background: #3979e3;
  color: #ffffff;
  border: 1px solid #3979e3 !important;
}
.custom-badge {
  position: absolute;
  top: -2px;
  left: -1px;
  // font-size: 9px;
  // color: #ffffff;
  background: url(../../assets/img/otgame/recharge_4.png) no-repeat;
  width: 38px;
  height: 33px;
  background-size: 100% 100%;
  // border-radius: 15px 15px 15px 0;
  // padding: 2px 3px;
  // min-width: 28px;
  // text-align: center;
}
.tool-tips-tail {
  position: absolute;
  top: 13px;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0px solid transparent; /* 左边框透明 */
  border-right: 5px solid transparent; /* 右边框透明 */
  border-top: 6px solid #dd0d42; /* 上边框设置颜色和宽度 */
}
.amount-box-list {
  flex-flow: wrap row;
  // margin-top: 20px;
}
.amount-box-list::after {
  content: '';
  width: 31.5%; /* 与.item宽度一致 */
  height: 0; /* 不占用高度 */
}

.amount-box-list-item {
  position: relative;
  border-radius: 8px;
  width: 31.5%;
  margin-bottom: 10px;
  background: #454654;
  padding: 7px 0;
}
.amount-bonus-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: linear-gradient(to right, #ff5d16, #ff9253);
  color: #ffffff;
  font-size: var(--vk-fs-2xs);
  padding: 1px 6px;
  border-radius: 0 8px 0 8px;
  font-weight: bold;
}
.first-recharge-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, rgba(255, 93, 22, 0.15), rgba(255, 146, 83, 0.08));
  border: 1px solid rgba(255, 93, 22, 0.3);
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 10px;
  &__text {
    color: #ff9253;
    font-size: var(--vk-fs-sm);
    font-weight: bold;
  }
}
.active {
  color: #ffffff !important;
  background: #007dfe;
}
::v-deep .van-checkbox__icon .van-icon {
  border: none !important;
}
/* 确保遮罩层覆盖整个屏幕 */
.full-screen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

::v-deep .van-loading {
  background-color: transparent !important;
  background: transparent !important;
}
.active-type {
  border-right: 1px solid #fa9614;
  border-top: 1px solid #fa9614;
  border-left: 1px solid #fa9614;
  background: #263144 !important;
  border-radius: 10px 10px 0 0 !important;
  height: 70px !important;
  margin-bottom: -11px;
}
.active-type2 {
  color: #ffffff !important;
  background: #3979e3 !important;
  border: 1px solid #3979e3 !important;
}
.active-type3 {
  border-radius: 0 10px 10px 10px !important;
}
</style>
